export const formatCronCadence = ( cronExpression: string ): string => {
  const parts = cronExpression.trim().split( /\s+/ );
  if ( parts.length !== 5 ) return cronExpression;
  const [ minute, hour, dom, month, dow ] = parts;

  const hoursMatch = hour.match( /^\*\/(\d+)$/ );
  if ( hoursMatch && dom === '*' && month === '*' && dow === '*' ) {
    const n = parseInt( hoursMatch[ 1 ] );
    return n === 1 ? 'Every hour' : `Every ${ n } hours`;
  }

  const daysMatch = dom.match( /^\*\/(\d+)$/ );
  if ( daysMatch && month === '*' && dow === '*' ) {
    const n = parseInt( daysMatch[ 1 ] );
    return n === 1 ? 'Every day' : `Every ${ n } days`;
  }

  if ( /^\d+$/.test( minute ) && /^\d+$/.test( hour ) && dom === '*' && month === '*' && dow === '*' ) {
    return `Daily at ${ hour.padStart( 2, '0' ) }:${ minute.padStart( 2, '0' ) }`;
  }

  return cronExpression;
};
